$(document).ready(function () {
  function updateMenubarWidth() {
    if ($(window).width() >= 1280) {
      var marginLeft = parseFloat($(".main-container").css("margin-left"));

      if (marginLeft !== 0) {
        var newWidth = 850 + marginLeft;
        $(".menubar.rechange-menubar").css("width", newWidth + "px");
      }

      $(".product-menu-item__container").css("display", "block");
    } else {
      if ($(window).width() < 400) {
        $(".menubar.rechange-menubar").css("width", "100%");
      } else {
        $(".menubar.rechange-menubar").css("width", "400px");
      }
      $(".product-menu-item__container").css("display", "none");
    }
  }

  updateMenubarWidth();

  $(window).resize(function () {
    updateMenubarWidth();
  });

  $(".p_single_card").on("click", function () {
    const href = $(this).find("> a").attr("href");
    if (href) {
      window.location.href = href;
    }
  });
});
